<td>
    <span class="status-badge" [ngClass]="getStatusClass(leave.status)">{{ getStatusText(leave.status) }}</span>
</td>
<td>
    <ng-container *ngIf="getErrorDetail(leave) as errorDetail">
        <div *ngIf="errorDetail.headline">{{ errorDetail.headline }}</div>
        <div class="error-detail" *ngIf="errorDetail.detail">{{ errorDetail.detail }}</div>
    </ng-container>
</td>
<td class="actions-cell">
    <button *ngIf="leave.status === 'JOB_ERFOLGREICH'"
            type="button"
            class="action-button retrieve-job-result-button"
            [title]="datevAuthService.getAuthStatus()() ? 'Jobergebnis jetzt abholen' : 'DATEV Authentifizierung erforderlich'"
            [disabled]="actionLoading() || !datevAuthService.getAuthStatus()()"
            (click)="retrieveJobResult()">
        Jobergebnis jetzt abholen
    </button>
    <button *ngIf="leave.status === 'JOB_ABGESCHLOSS'"
            type="button"
            class="action-button create-eau-button"
            [title]="datevAuthService.getAuthStatus()() ? 'eAU jetzt anlegen' : 'DATEV Authentifizierung erforderlich'"
            [disabled]="actionLoading() || !datevAuthService.getAuthStatus()()"
            (click)="createEau()">
        eAU jetzt anlegen
    </button>
    <button *ngIf="leave.status === 'EAU_ERSTELLT'"
            type="button"
            class="action-button submit-button"
            [title]="datevAuthService.getAuthStatus()() ? 'Jetzt einreichen' : 'DATEV Authentifizierung erforderlich'"
            [disabled]="actionLoading() || !datevAuthService.getAuthStatus()()"
            (click)="submitEau()">
        Jetzt einreichen
    </button>
    <button *ngIf="leave.status === 'EAU_EINGEREICHT'"
            type="button"
            class="action-button retrieve-button"
            [title]="datevAuthService.getAuthStatus()() ? 'Rückmeldung jetzt abholen' : 'DATEV Authentifizierung erforderlich'"
            [disabled]="actionLoading() || !datevAuthService.getAuthStatus()()"
            (click)="retrieveFeedback()">
        Rückmeldung jetzt abholen
    </button>
    <button *ngIf="leave.status === 'EAU_CANCEL'"
            type="button"
            class="action-button cancel-button"
            [title]="datevAuthService.getAuthStatus()() ? 'Jetzt stornieren' : 'DATEV Authentifizierung erforderlich'"
            [disabled]="actionLoading() || !datevAuthService.getAuthStatus()()"
            (click)="cancelFeedback()">
        Jetzt stornieren
    </button>
    <span class="action-loading" *ngIf="actionLoading()">Wird ausgeführt...</span>
    <div class="action-error" *ngIf="actionError() as actionErrorMessage">{{ actionErrorMessage }}</div>
</td>
